"use client";

import React from "react";
import partners from "@/content/partners.json";
import Link from "next/link";

const PartnersElement: React.FC = () => {
  const renderGrid = (items: typeof partners.patronaty | typeof partners.medialne | typeof partners.wspolprace) => {
    return (
      <div className="grid md:grid-cols-3 grid-cols-2">
        {items.map((el, index) => {
          const isLast = index === items.length - 1;

          const getColStart = () => {
            if (!isLast) return "";
            const mdCols = 3;
            const smCols = 2;

            if (items.length % mdCols === 1) return "md:col-start-2";
            if (items.length % mdCols === 2) return "md:col-start-2";

            return "";
          };

          const getColStartSm = () => {
            if (!isLast) return "";
            const smCols = 2;
            if (items.length % smCols === 1) return "max-md:col-span-2";
            return "";
          };

          return (
            <Link
              key={index}
              href={el.href}
              className={`select-none outline-none h-[11rem] min-w-[9rem] transition-all duration-300 flex items-center justify-center ${getColStart()} ${getColStartSm()}`}
            >
              <img src={el.src} alt={el.alt} className="h-[11rem] object-contain" />
            </Link>
          );
        })}
      </div>
    );
  };

  return (
    <div className="p-14 w-full overflow-hidden relative flex gap-10 text-white16">
      <div className="w-full">
        <h2 className="text-4xl text-center">Patronaty Honorowe</h2>
        {renderGrid(partners.patronaty)}
      </div>
      <div className="w-full">
        <h2 className="text-4xl text-center">Patronaty Medialne</h2>
        {renderGrid(partners.medialne)}
      </div>
      <div className="w-full">
        <h2 className="text-4xl text-center">Współprace</h2>
        {renderGrid(partners.wspolprace)}
      </div>
    </div>
  );
};

export default PartnersElement;
